import type { CallStatus } from "./types";

// How long a call rings before the server records it as missed.
export const ringMs = 45000;
export const isLiveCall = (status: CallStatus) =>
  status === "ringing" || status === "active";
// isLiveCall for a SQL expression holding a call's status.
export const liveCallSql = (status: string) =>
  `${status} IN ('ringing','active')`;
